export default "__VITE_ASSET__ywPnK14U__"